export default {
  placeholder: 'Wybierz zadania konserwacyjne',
  unit: 'Strony',
};
